import type { ReactElement } from 'react';
import * as React from 'react';
import { Text, Icon, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

interface SuccessMessageWithIconProps {
  message: string;
  className?: string;
}

const StyledIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1};
`;

export const SuccessMessageWithIcon = ({
  message,
  className,
}: SuccessMessageWithIconProps): ReactElement => {
  return (
    <div className={className}>
      <StyledIcon color="text_success" icon="check" inline />
      <Text textColor="text_success">{message}</Text>
    </div>
  );
};
